/**
 * Utilitaires pour la gestion des PDF
 */

/**
 * Télécharge un blob en tant que fichier PDF
 * @param blob - Le blob PDF à télécharger
 * @param filename - Le nom du fichier sans extension
 */
export const downloadPDF = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Ouvre un PDF dans un nouvel onglet
 * @param blob - Le blob PDF à ouvrir
 */
export const openPDFInNewTab = (blob: Blob): void => {
  const url = window.URL.createObjectURL(blob);
  window.open(url, '_blank');
  // Note: On ne révoque pas l'URL immédiatement car l'onglet en a besoin
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};

/**
 * Gère les erreurs d'impression PDF
 * @param error - L'erreur survenue
 * @param type - Le type de document (ordonnance, facture, etc.)
 */
export const handlePrintError = (error: any, type: string): void => {
  console.error(`Erreur lors de l'impression ${type}:`, error);
  
  if (error.response?.status === 404) {
    alert(`Aucune ${type} trouvée pour cette consultation.`);
  } else if (error.response?.status === 500) {
    alert(`Erreur serveur lors de la génération du PDF de ${type}.`);
  } else {
    alert(`Erreur lors de l'impression de ${type}. Veuillez réessayer.`);
  }
};